import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoFooter from "../../assets/logoFooter.png";
import { getFirestore } from "../../config/firebase";
import { buildRouteWithUtms } from "../../config/whatsappConfig";
import { useLocation } from "react-router-dom";

const FOOTER_PHONE = "0810-444-1111";
const FOOTER_PHONE_TEL = "08104441111";

const ICON_TELEFONO = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"
      fill="#fff"
    />
  </svg>
);

const Footer = ({ bg }) => {
  const location = useLocation();

  /* sessionStorage.setItem('saludo', 'Bienvenidos a localStorage');
  valor = sessionStorage.getItem('saludo');
  */

  const [redesSociales, setRedesSociales] = useState([]);

  useEffect(() => {
    // Función para cargar datos desde localStorage o Firebase
    const cargarDatos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = sessionStorage.getItem("redesSociales");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setRedesSociales(JSON.parse(datosLocales));
      } else {
        // Si no están en localStorage, obtenerlos de Firebase
        const db = getFirestore();
        try {
          const datos = await db.collection("ford-informacion").get();
          const arrayDatos = datos.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setRedesSociales(arrayDatos[0]);
          // Almacenar los datos en localStorage
          sessionStorage.setItem("redesSociales", JSON.stringify(arrayDatos[0]));
        } catch (error) {
          console.log(error);
        }
      }
    };

    // Llamar a la función para cargar datos
    cargarDatos();
  }, []);

  return (
    <>
      <Container fluid className="footer mt-4">
        <Container>
          <Row>
            <div>
              <Col
                md={12}
                xs={12}
                className="text-sm-start text-center pt-3 d-flex align-items-center gap-5 columnas-foots-centrar-mobile"
              >
                <Link to={buildRouteWithUtms("/todos", location.search)}>
                  <img src={logoFooter} alt="Montironi Ford" className="img-fluid" />
                </Link>
                <p className="legal ocultar-mobile-legal">
                  El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                  parcial o total sin previo aviso.
                </p>
              </Col>
              <Col
                md={12}
                xs={12}
                className="pt-3 social d-flex align-items-center flex-wrap gap-3 footer-contacto-redes columna-seguinos-en"
              >
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <span style={{ margin: "0 4px", verticalAlign: "middle", display: "inline-flex" }}>
                    {ICON_TELEFONO}
                  </span>
                  <a
                    href={`tel:${FOOTER_PHONE_TEL}`}
                    style={{ color: "#fff", textDecoration: "underline", fontFamily: "inherit", fontSize: "18px" }}
                  >
                    {FOOTER_PHONE}
                  </a>
                </div>
                <div className="d-flex align-items-center gap-2 ms-md-auto">
                  <p>Seguinos en:</p>
                  <div>
                    {redesSociales.redes &&
                      redesSociales.redes.map((red) => {
                        return red.disponible ? (
                          <a href={red.url} target="_blank" rel="noreferrer" className="px-2" key={red.url}>
                            <img src={red.url_icon} alt="Logo" />
                          </a>
                        ) : null;
                      })}
                  </div>
                </div>
              </Col>
              <Col md={12} xs={12} className=" pt-3 social d-flex align-items-center mostrar-mobile-legal">
                <p className="legal">
                  El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                  parcial o total sin previo aviso.
                </p>
              </Col>
            </div>
          </Row>
        </Container>
      </Container>
      <Container fluid className="copyright">
        <Container>
          <Row>
            <Col md={12} xs={12} className="text-center">
              <p>
                Copyright © {new Date().getFullYear()} Montironi Ford - Todos los derechos reservados - Políticas de
                Seguridad
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default Footer;

